module.exports = __webpack_public_path__ + "static/media/ring.a2259863.png";